import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";

export function HtmlFrame({ html, testId = "report-html-frame", className = "h-[70vh]" }) {
  return <iframe title="Report preview" srcDoc={html} sandbox="" className={`w-full rounded-md border border-slate-200 bg-[#F8FAFC] ${className}`} data-testid={testId} />;
}

export function ReportPreviewSheet({ preview, onClose }) {
  return (
    <Sheet open={!!preview} onOpenChange={(o) => !o && onClose()}>
      <SheetContent className="w-full overflow-y-auto sm:max-w-4xl" data-testid="report-preview-sheet">
        <SheetHeader><SheetTitle className="text-[#101C47]">Preview · {preview?.title}</SheetTitle><SheetDescription>Exactly what the email body will contain for period {preview?.period?.label} ({preview?.period?.basis}). Not stored, not sent.{preview?.size_bytes ? ` ${(preview.size_bytes / 1024).toFixed(1)} KB.` : ""}</SheetDescription></SheetHeader>
        <div className="mt-4">{preview && <HtmlFrame html={preview.html} />}</div>
      </SheetContent>
    </Sheet>
  );
}
